export function formatNumber(num: string | number) {
  const number = typeof num === 'string' ? parseFloat(num) : num;
  return Number(number.toFixed(2));
}
